var blockBundles;

try {
  blockBundles = {
    revelation__s27: {
      header: {
        header: {
          html: require("../../revelation__s27/header/header.html.twig"),
          scss: require("../../revelation__s27/header/header.scss"),
          js: require("../../revelation__s27/header/header.js"),
          dir: "revelation__s27/header/header",
        },
      },
      content: {
        frame_vongquay: {
          html: require("../../revelation__s27/frame_vongquay/frame_vongquay.html.twig"),
          scss: require("../../revelation__s27/frame_vongquay/frame_vongquay.scss"),
          js: require("../../revelation__s27/frame_vongquay/frame_vongquay.js"),
          dir: "revelation__s27/frame_vongquay/frame_vongquay",
        },
        popup: {
          html: require("../../revelation__s27/popup/popup.html.twig"),
          scss: require("../../revelation__s27/popup/popup.scss"),
          js: require("../../revelation__s27/popup/popup.js"),
          dir: "revelation__s27/popup/popup",
        },
        popup_content: {
          html: require("../../revelation__s27/popup_content/popup_content.html.twig"),
          scss: require("../../revelation__s27/popup_content/popup_content.scss"),
          js: require("../../revelation__s27/popup_content/popup_content.js"),
          dir: "revelation__s27/popup_content/popup_content",
        },
        menu_bottom: {
          html: require("../../revelation__s27/menu_bottom/menu_bottom.html.twig"),
          scss: require("../../revelation__s27/menu_bottom/menu_bottom.scss"),
          js: require("../../revelation__s27/menu_bottom/menu_bottom.js"),
          dir: "revelation__s27/menu_bottom/menu_bottom",
        },
        bxh: {
          html: require("../../revelation__s27/bxh/bxh.html.twig"),
          scss: require("../../revelation__s27/bxh/bxh.scss"),
          js: require("../../revelation__s27/bxh/bxh.js"),
          dir: "revelation__s27/bxh/bxh",
        },
        vongquay: {
          html: require("../../revelation__s27/vongquay/vongquay.html.twig"),
          scss: require("../../revelation__s27/vongquay/vongquay.scss"),
          js: require("../../revelation__s27/vongquay/vongquay.js"),
          dir: "revelation__s27/vongquay/vongquay",
        },
        gift: {
          html: require("../../revelation__s27/gift/gift.html.twig"),
          scss: require("../../revelation__s27/gift/gift.scss"),
          js: require("../../revelation__s27/gift/gift.js"),
          dir: "revelation__s27/gift/gift",
        },
      },

      float: {
        float_left: {
          html: require("../../revelation__s27/float_left/float_left.html.twig"),
          scss: require("../../revelation__s27/float_left/float_left.scss"),
          js: require("../../revelation__s27/float_left/float_left.js"),
          dir: "revelation__s27/float_left/float_left",
        },

        float_right: {
          html: require("../../revelation__s27/float_right/float_right.html.twig"),
          scss: require("../../revelation__s27/float_right/float_right.scss"),
          js: require("../../revelation__s27/float_right/float_right.js"),
          dir: "revelation__s27/float_right/float_right",
        },
        float_top: {
          html: require("../../revelation__s27/float_top/float_top.html.twig"),
          scss: require("../../revelation__s27/float_top/float_top.scss"),
          js: require("../../revelation__s27/float_top/float_top.js"),
          dir: "revelation__s27/float_top/float_top",
        },
      },
    },
    common: {
      required: {
        required_loading: {
          html: require("../../common/required_loading/required_loading.html.twig"),
          scss: require("../../common/required_loading/required_loading.scss"),
          js: require("../../common/required_loading/required_loading.js"),
          dir: "common/required_loading/required_loading",
        },
      },
    },
  };
} catch (error) {
  console.log(error);
}

export default blockBundles;
